import React, { useState, useEffect } from "react";

function App() {
  const [classes, setClasses] = useState({});
  const [selectedClasses, setSelectedClasses] = useState([{ name: "Nenhum", level: 1 }]); // Começar com a classe Nenhum
  const [attributes, setAttributes] = useState({});
  const [totalLevel, setTotalLevel] = useState(1); // Nível total começa em 1
  const [customValues, setCustomValues] = useState({}); // Para armazenar os valores personalizados
  const [modifiers, setModifiers] = useState({}); // Para armazenar os modificadores de porcentagem

  // Carregar as classes do JSON
  useEffect(() => {
    fetch("/classes.json")
      .then((response) => response.json())
      .then((data) => {
        setClasses(data);
        setAttributes(data["Nenhum"]); // Atributos iniciais são baseados em Nenhum
      })
      .catch((error) => console.error("Erro ao carregar o JSON:", error));
  }, []);

  // Calcular os atributos totais com base nas classes selecionadas
  useEffect(() => {
    const calculatedAttributes = { HP: 0, Mana: 0, Stamina: 0, DMG: 0, MAG: 0, DEF: 0, RMA: 0, SPD: 0, DES: 0, FOR: 0, PRE: 0 };
    let totalLevel = 0;

    selectedClasses.forEach(({ name, level }, index) => {
      const baseAttributes = classes[name]?.base;
      const levelAttributes = classes[name]?.nivel;

      if (baseAttributes) {
        totalLevel += level;
        Object.keys(baseAttributes).forEach((key) => {
          const baseValue = baseAttributes[key];
          const levelValue = levelAttributes && levelAttributes[key] ? levelAttributes[key] : 1; // Se não houver nivel para o atributo, usa +1 por padrão

          // A primeira classe usa base no nível 1, e as outras usam nivel
          if (index === 0) {
            // Para a primeira classe, usa "base" para o nível 1 e "nivel" para os níveis seguintes
            if (level === 1) {
              calculatedAttributes[key] += baseValue;
            } else {
              calculatedAttributes[key] += baseValue + (level - 1) * levelValue;
            }
          } else {
            // Para as classes secundárias, sempre usa "nivel" para todos os níveis a partir do nível 1
            if (level === 1) {
              // Para o nível 1 da classe secundária, usa o valor de nivel, não base
              calculatedAttributes[key] += levelAttributes[key] || 1;
            } else {
                // Para os níveis subsequentes, sempre usa o valor de nivel multiplicado pela diferença
                calculatedAttributes[key] += levelAttributes[key] * (level) || 1;
            }
          }
        });
      }
    });

    // Aplicar valores personalizados
    Object.keys(calculatedAttributes).forEach((key) => {
      if (customValues[key]) {
        calculatedAttributes[key] += customValues[key];
      }
    });

    // Aplicar modificadores
    Object.keys(calculatedAttributes).forEach((key) => {
      if (modifiers[key]) {
        calculatedAttributes[key] += (calculatedAttributes[key] * modifiers[key]) / 100;
      }
    });

    setAttributes(calculatedAttributes);
    setTotalLevel(totalLevel);
  }, [selectedClasses, classes, customValues, modifiers]);

  // Adicionar nova classe
  const addClass = () => {
    if (selectedClasses.length < 4 && totalLevel < 25) {
      setSelectedClasses([...selectedClasses, { name: "Nenhum", level: 1 }]);
    }
  };

  // Remover classe
  const removeClass = (index) => {
    const updatedClasses = selectedClasses.filter((_, i) => i !== index);
    setSelectedClasses(updatedClasses);
  };

  // Atualizar classe e nível
  const handleClassChange = (index, className) => {
    const updatedClasses = [...selectedClasses];
    updatedClasses[index].name = className;
    setSelectedClasses(updatedClasses);
  };

  const handleLevelChange = (index, level) => {
    if (selectedClasses[index].name === "Nenhum") return; // Não permite alterar o nível de "Nenhum"

    // Calcular o nível máximo que a classe pode alcançar
    const remainingLevels = 25 - totalLevel + selectedClasses[index].level;
    const updatedClasses = [...selectedClasses];
    updatedClasses[index].level = Math.min(remainingLevels, level); // Não permite exceder o limite
    setSelectedClasses(updatedClasses);
  };

  // Calcular as opções de níveis disponíveis para cada classe
  const getAvailableLevels = (index) => {
    const remainingLevels = 25 - totalLevel + selectedClasses[index].level;
    return Array.from({ length: remainingLevels }, (_, i) => i + 1);
  };

  // Atualizar valor personalizado para um atributo
  const handleCustomValueChange = (attribute, value) => {
    setCustomValues({
      ...customValues,
      [attribute]: parseInt(value) || 0,
    });
  };

  // Atualizar modificador percentual para um atributo
  const handleModifierChange = (attribute, value) => {
    setModifiers({
      ...modifiers,
      [attribute]: parseInt(value) || 0,
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h1>Selecione suas Classes</h1>
      <div>
        <h2>Classes Selecionadas: {selectedClasses.map(({ name }) => name).join(" / ")} - Nível Total {totalLevel}</h2>
        {selectedClasses.map((classData, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <select
              value={classData.name}
              onChange={(e) => handleClassChange(index, e.target.value)}
              style={{ fontSize: "16px", padding: "5px", margin: "10px" }}
            >
              {Object.keys(classes).map((cls) => (
                <option key={cls} value={cls}>
                  {cls}
                </option>
              ))}
            </select>
            {classData.name !== "Nenhum" && (
              <select
                value={classData.level}
                onChange={(e) => handleLevelChange(index, parseInt(e.target.value))}
                style={{ fontSize: "16px", padding: "5px", margin: "10px" }}
              >
                {getAvailableLevels(index).map((lvl) => (
                  <option key={lvl} value={lvl}>
                    Nível {lvl}
                  </option>
                ))}
              </select>
            )}
            <span style={{ marginLeft: "10px", fontWeight: "bold" }}>
              Nível Atual: {classData.level}
            </span>
            <button onClick={() => removeClass(index)} style={{ marginLeft: "10px" }}>
              Remover
            </button>
          </div>
        ))}
        {selectedClasses.length < 4 && totalLevel < 25 && (
          <button onClick={addClass} style={{ fontSize: "16px", padding: "10px", marginTop: "20px" }}>
            Adicionar Classe
          </button>
        )}
      </div>

      <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h2>Atributos Totais</h2>
        <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", width: "100%", maxWidth: "300px" }}>
          {Object.entries(attributes).map(([key, value]) => (
            <li
              key={key}
              style={{
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // Garante que os itens se distribuam corretamente
                marginBottom: "10px",
                width: "100%",
                textAlign: "left", // Garante que o texto seja alinhado à esquerda
              }}
            >
              <div style={{ flex: 1 }}>
                <strong>{key}:</strong> {value}
              </div>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                <input
                  type="number"
                  placeholder="0"
                  style={{
                    width: "60px", // Tamanho fixo para os inputs
                    padding: "5px",
                    textAlign: "center" // Centraliza o texto no input
                  }}
                  onChange={(e) => handleCustomValueChange(key, e.target.value)}
                />
                <input
                  type="number"
                  placeholder="0%"
                  style={{
                    width: "60px", // Tamanho fixo para os inputs
                    padding: "5px",
                    textAlign: "center" // Centraliza o texto no input
                  }}
                  onChange={(e) => handleModifierChange(key, e.target.value)}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;
